import api from './api';

export type SearchType = 'order' | 'shipment' | 'contact';

export interface SearchHit {
  id: number | string;
  type: SearchType;
  title: string;
  subtitle: string;
  meta: Record<string, unknown>;
  route: string;
}

export interface SearchResponse {
  query: string;
  orders: SearchHit[];
  shipments: SearchHit[];
  contacts: SearchHit[];
  total: number;
}

export interface SearchOptions {
  limit?: number;
  types?: SearchType[];
  signal?: AbortSignal;
}

/**
 * Call the global search endpoint. Returns categorized results scoped to the
 * authenticated user. The backend enforces a minimum query length of 2 chars.
 */
export async function globalSearch(query: string, options: SearchOptions = {}): Promise<SearchResponse> {
  const { limit = 5, types, signal } = options;

  const params: Record<string, string | number> = { q: query, limit };
  if (types && types.length > 0) {
    params.types = types.map(typeToParam).join(',');
  }

  const response = await api.get('/search', { params, signal });

  const data = response.data?.data ?? response.data ?? {};

  return {
    query: data.query ?? query,
    orders: Array.isArray(data.orders) ? data.orders : [],
    shipments: Array.isArray(data.shipments) ? data.shipments : [],
    contacts: Array.isArray(data.contacts) ? data.contacts : [],
    total: typeof data.total === 'number' ? data.total : 0,
  };
}

function typeToParam(t: SearchType): string {
  if (t === 'order') return 'orders';
  if (t === 'shipment') return 'shipments';
  return 'contacts';
}

const searchService = { globalSearch };
export default searchService;
